import { ref } from "vue";

export const messageAlertSelectProductHappyEmpty = {
    option: [],
    type: "",
    message: "",
    title: ""
}

export interface messageAlertSelectProductHappyEmpty {
    option: any[]
    type: string,
    message: string
    title: string
}
export const messageAlertSelectProductHappy = ref<messageAlertSelectProductHappyEmpty>(messageAlertSelectProductHappyEmpty)